<panel *ngIf="!loading || !users.empty">
  <p header>{{"Danh sách tài khoản" | lang}}</p>
  <div class="flex" right>
    <text-filter [target]="users" [placeholder]="'Tìm kiếm'"></text-filter>
    <button class="bg-primary text-white std-margin-left" (click)="edit(null)"><i class="fa fa-plus"></i></button>
  </div>
  <table class="data hover" responsive>
    <tr>
      <th class="text-right" style="width: 0">STT</th>
      <th class="text-center">{{"Mã" | lang}}</th>
      <th class="text-left">{{"Tên đăng nhập" | lang}}</th>
      <th class="text-right">{{"Vai trò" | lang}}</th>
    </tr>
    <tr *ngFor="let i of users.pageMatches; index as ix" (click)="edit(i)" class="pointer">
      <td><small>{{ix + 1 + users.pageIndex * users.pageSize}}</small></td>
      <td class="spacy">TK{{i.ID}}</td>
      <td class="lowercase text-primary bold">{{i.Username}}</td>
      <td><small class="small uppercase button {{info(x).class}}" *ngFor="let x of i.Roles">{{info(x).name}}</small></td>
    </tr>
    <tr class="footer" *ngIf="users.matches.length > users.pageSize">
      <td [colSpan]="4" class="text-center"><pagination [target]="users"></pagination></td>
    </tr>
  </table>
</panel>
<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
